import Needs from "@/views/needs/needs/Needs.vue";
import Need from "@/views/needs/need/Need.vue";

export default [
    {
        path: '/needs',
        component: Needs,
        meta: {
            access: ['enterprise'],
        }
    },
    {
        path: '/needs/:id',
        component: Need,
        meta: {
            access: ['enterprise']
        }
    },
]
